import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import PhoneNumberWithoutFormatter from './PhoneNumberWithoutFormatter';

let formatter = null;
const getFormatter = () => formatter;
export const fetchFormatter = async () => {
    const awesomePhonenumber = await import('awesome-phonenumber');
    formatter = new awesomePhonenumber.getAsYouType('US');
};

class PhoneNumberWithDelayedImport extends PureComponent {
    static propTypes = {
        initialValue: PropTypes.string,
        invalidMessage: PropTypes.string,
        onChange: PropTypes.func,
        onEdit: PropTypes.func,
        presentationMode: PropTypes.bool,
        validationFunction: PropTypes.func,
    };

    render() {
        return (
            <PhoneNumberWithoutFormatter
                getFormatter={getFormatter}
                {...this.props}
            />
        );
    }

    componentDidMount() {
        if (!formatter) {
            fetchFormatter().then(() => this.setState({ loaded: true })); // eslint-disable-line
        }
    }
}

export {
    PhoneNumberWithDelayedImport as default,
    PhoneNumberWithDelayedImport,
};
